<div
    class="bg"
    *ngIf="!env.BUS_ICON_TYPE && !generalBusIcon"
    [ngClass]="{
        'default': !selectedBus,
        'active': selectedBus && selectedBus.location_id === bus.location_id,
        'disabled': selectedBus && selectedBus.location_id !== bus.location_id,
        'enlarged-marker': enlargedMarkers,
        'bus-selected': isBusSelected
    }"
    [ngStyle]="{ transform: 'rotate(' + bus.bearing + 'deg)' }">
    <div
        class="text"
        [ngStyle]="{ transform: 'rotate(' + bus.bearing * -1 + 'deg)' }"
        [ngClass]="{ '!text-[10px]': bus.route_short_name.length > 3 }"
        (click)="onBusClicked(bus, $event)">
        {{ bus.route_short_name }}
    </div>
</div>

<div
    class="bus-icon relative"
    *ngIf="env.BUS_ICON_TYPE === BUS_ICON_TYPE.DYNAMIC && !generalBusIcon"
    [ngClass]="{ 'bus-selected': isBusSelected }"
    (click)="onBusClicked(bus, $event)">
    <div
        class="sr-app-light:top-[calc(50%+2px)] bus-text absolute left-1/2 top-1/2 z-10 -translate-x-1/2 -translate-y-1/2 transform font-bold text-white"
        [ngStyle]="{ color: markerTextColor }"
        [ngClass]="busTextClasses">
        {{ bus.route_short_name }}
    </div>
    <div class="bus-icon-container h-full w-full" [ngStyle]="{ transform: 'rotate(' + bus.bearing + 'deg)' }">
        <div
            class="flex h-full w-full items-center justify-center border-2 border-solid border-white dark:border-contrast-black"
            [ngStyle]="{
                'background-color': markerColor,
                'border-radius': !bus.bus_speed ? '50%' : '50% 50% 50% 0',
                'rotate': '135deg'
            }"></div>
    </div>
</div>

<div class="bg pb-2 pr-2" *ngIf="generalBusIcon">
    <ng-container *ngIf="env.SHOW_LINE_BUS_HEADING">
        <ng-container
            *ngTemplateOutlet="
                !bus?.bus_speed ? generalIcon : busMoving;
                context: { color: markerColor, bus: bus }
            "></ng-container>
    </ng-container>
    <ng-container *ngIf="!env.SHOW_LINE_BUS_HEADING">
        <ng-container *ngTemplateOutlet="generalIcon; context: { color: markerColor }"></ng-container>
    </ng-container>
</div>

<ng-template #generalIcon let-color="color">
    <svg
        class="bus-icon"
        [ngClass]="{ 'bus-selected': isBusSelected }"
        [ngStyle]="{ position: 'absolute', left: '-20%' }"
        width="36"
        height="36"
        viewBox="0 0 36 36"
        fill="none"
        xmlns="http://www.w3.org/2000/svg">
        <path
            [attr.fill]="color"
            d="M18 28.5C24.9036 28.5 30.5 22.9036 30.5 16C30.5 9.09644 24.9036 3.5 18 3.5C11.0964 3.5 5.5 9.09644 5.5 16C5.5 22.9036 11.0964 28.5 18 28.5Z" />
        <path
            d="M18 4C24.63 4 30 9.37 30 16C30 22.63 24.63 28 18 28C11.37 28 6 22.63 6 16C6 9.37 11.37 4 18 4ZM18 3C10.83 3 5 8.83 5 16C5 23.17 10.83 29 18 29C25.17 29 31 23.17 31 16C31 8.83 25.17 3 18 3Z"
            fill="white" />
        <path
            d="M18 9C21.3429 9 24 9.94286 24 11.1429V11.5714V20.1429C24 20.617 23.617 21 23.1429 21V21.8571C23.1429 22.3313 22.7598 22.7143 22.2857 22.7143H21.4286C20.9545 22.7143 20.5714 22.3313 20.5714 21.8571V21H15.4286V21.8571C15.4286 22.3313 15.0455 22.7143 14.5714 22.7143H13.7143C13.2402 22.7143 12.8571 22.3313 12.8571 21.8571V21C12.383 21 12 20.617 12 20.1429V11.5714V11.1429C12 9.94286 14.6571 9 18 9ZM13.7143 12.4286V15.8571C13.7143 16.3313 14.0973 16.7143 14.5714 16.7143H21.4286C21.9027 16.7143 22.2857 16.3313 22.2857 15.8571V12.4286C22.2857 11.9545 21.9027 11.5714 21.4286 11.5714H14.5714C14.0973 11.5714 13.7143 11.9545 13.7143 12.4286ZM14.1429 19.7143C14.3702 19.7143 14.5882 19.624 14.7489 19.4632C14.9097 19.3025 15 19.0845 15 18.8571C15 18.6298 14.9097 18.4118 14.7489 18.2511C14.5882 18.0903 14.3702 18 14.1429 18C13.9155 18 13.6975 18.0903 13.5368 18.2511C13.376 18.4118 13.2857 18.6298 13.2857 18.8571C13.2857 19.0845 13.376 19.3025 13.5368 19.4632C13.6975 19.624 13.9155 19.7143 14.1429 19.7143ZM21.8571 19.7143C22.0845 19.7143 22.3025 19.624 22.4632 19.4632C22.624 19.3025 22.7143 19.0845 22.7143 18.8571C22.7143 18.6298 22.624 18.4118 22.4632 18.2511C22.3025 18.0903 22.0845 18 21.8571 18C21.6298 18 21.4118 18.0903 21.2511 18.2511C21.0903 18.4118 21 18.6298 21 18.8571C21 19.0845 21.0903 19.3025 21.2511 19.4632C21.4118 19.624 21.6298 19.7143 21.8571 19.7143Z"
            fill="white" />
    </svg>
</ng-template>

<ng-template #busMoving let-color="color" let-bus="bus">
    <svg
        class="bus-icon"
        [ngClass]="{ 'bus-selected': isBusSelected }"
        [ngStyle]="{ position: 'absolute', left: '-20%', scale: '1.222' }"
        width="44"
        height="44"
        viewBox="0 0 44 44"
        fill="none"
        xmlns="http://www.w3.org/2000/svg">
        <path
            class="dark:text-contrast-black"
            [attr.stroke]="'white'"
            [attr.stroke-width]="'2px'"
            [attr.fill]="color"
            [ngStyle]="{
                'transform': 'rotate(' + (bus.bearing + 180) + 'deg)',
                'transform-origin': 'center'
            }"
            d="M22.0001 9.50002L21.9993 9.50002C19.9686 9.49648 17.9677 9.99003 16.1703 10.9386C14.3729 11.8873 12.8331 13.2619 11.6849 14.9434C10.5368 16.625 9.81498 18.5625 9.58224 20.5877L9.58223 20.5877C9.3494 22.613 9.61282 24.6646 10.3495 26.5644L10.3505 26.5671C10.3693 26.6163 10.3892 26.6738 10.4056 26.7208C10.4105 26.7351 10.4152 26.7484 10.4193 26.7602C10.4394 26.8073 10.4584 26.8535 10.4756 26.8955L10.4798 26.9058C10.5007 26.9568 10.5194 27.0019 10.5387 27.0459L10.5388 27.0458L10.5434 27.0571C11.9201 30.4144 14.816 34.037 17.4044 36.8456C18.6928 38.2437 19.894 39.4284 20.773 40.2635C21.2124 40.6809 21.5708 41.0106 21.819 41.2355C21.8793 41.2902 21.9331 41.3387 21.9799 41.3807C22.0169 41.3475 22.0582 41.3104 22.1036 41.2693C22.3282 41.0663 22.6535 40.7681 23.0543 40.3895C23.8562 39.6319 24.9592 38.5533 26.1626 37.2701C28.5774 34.6949 31.3645 31.329 32.9523 28.0959L32.9622 28.0767C34.0053 26.166 34.5347 24.0156 34.4982 21.8371C34.4618 19.6585 33.8608 17.5271 32.7544 15.6526C31.6481 13.7782 30.0746 12.2253 28.1889 11.1465C26.3033 10.0678 24.1704 9.50042 22.0001 9.50002Z"
            stroke="black"
            stroke-linejoin="bevel" />
        <path
            [attr.fill]="'white'"
            d="M22 15C25.3429 15 28 15.9429 28 17.1429V17.5714V26.1429C28 26.617 27.617 27 27.1429 27V27.8571C27.1429 28.3313 26.7598 28.7143 26.2857 28.7143H25.4286C24.9545 28.7143 24.5714 28.3313 24.5714 27.8571V27H19.4286V27.8571C19.4286 28.3313 19.0455 28.7143 18.5714 28.7143H17.7143C17.2402 28.7143 16.8571 28.3313 16.8571 27.8571V27C16.383 27 16 26.617 16 26.1429V17.5714V17.1429C16 15.9429 18.6571 15 22 15ZM17.7143 18.4286V21.8571C17.7143 22.3313 18.0973 22.7143 18.5714 22.7143H25.4286C25.9027 22.7143 26.2857 22.3313 26.2857 21.8571V18.4286C26.2857 17.9545 25.9027 17.5714 25.4286 17.5714H18.5714C18.0973 17.5714 17.7143 17.9545 17.7143 18.4286ZM18.1429 25.7143C18.3702 25.7143 18.5882 25.624 18.7489 25.4632C18.9097 25.3025 19 25.0845 19 24.8571C19 24.6298 18.9097 24.4118 18.7489 24.2511C18.5882 24.0903 18.3702 24 18.1429 24C17.9155 24 17.6975 24.0903 17.5368 24.2511C17.376 24.4118 17.2857 24.6298 17.2857 24.8571C17.2857 25.0845 17.376 25.3025 17.5368 25.4632C17.6975 25.624 17.9155 25.7143 18.1429 25.7143ZM25.8571 25.7143C26.0845 25.7143 26.3025 25.624 26.4632 25.4632C26.624 25.3025 26.7143 25.0845 26.7143 24.8571C26.7143 24.6298 26.624 24.4118 26.4632 24.2511C26.3025 24.0903 26.0845 24 25.8571 24C25.6298 24 25.4118 24.0903 25.2511 24.2511C25.0903 24.4118 25 24.6298 25 24.8571C25 25.0845 25.0903 25.3025 25.2511 25.4632C25.4118 25.624 25.6298 25.7143 25.8571 25.7143Z" />
    </svg>
</ng-template>
